import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { SwiperComponent } from 'swiper/angular';
// import Swiper core and required modules
import SwiperCore, { Navigation, Pagination } from 'swiper';
import {
  LoadingController,
  NavController,
  Platform,
  PopoverController,
  ToastController,
} from '@ionic/angular';
import { Location } from "@angular/common";
import { RestService } from 'src/app/services/rest.service';
import { ExtendedProfile } from '../../../models/commons/extendedProfile';
import { SharedVarModalService } from '../../services/shared-var-modal.service';
import { ShareMenu } from 'share-menu';
import { BuyerCurrencyAmount, CurrencyAmount, ReferedInterface, TableRefered } from 'src/app/models/commons/ReferedInterface';


// install Swiper modules
SwiperCore.use([Navigation, Pagination]);

interface AccordionTableRow {
  id: number;
  name: string;
  status: string;
  cash: string;
  expanded?: boolean; // Optional flag to track expanded state
}
@Component({
  selector: 'app-referred',
  templateUrl: './referred.page.html',
  styleUrls: ['./referred.page.scss'],
})
export class ReferredPage implements OnInit, AfterContentChecked {
  @ViewChild('swiper') swiper: SwiperComponent;
  modalShowAlertDelete: boolean;
  isOpenPost = false;
  refereds: ReferedInterface;
  modalShowAlertDeleteDisc: boolean;
  isOpenEditDisc = false;
  modalShowRegisterTelco: boolean;
  dataPost: any;
  profile: any;
  dataSlider: any[] = [];
  dataDynamic: any[] = [];
  dataSearchSlider: any[] = [];
  showModalPublishDisc: boolean = false;
  edit: boolean = true;
  helpAlbum: boolean = false;
  sectionEdit: string = null;
  disabledEdit: boolean = false;
  seeAllAlbumsEdit: boolean;
  selectedDiscSpotifyImg: string;
  selectedDiscSpotifyArtist: string;
  selectedDiscSpotifyName: string;
  showSelectedDiscSpotify: boolean;
  private selectedDiscSpotifyReleaseDate: string;
  private selectedDiscSpotifyExternalUrl: string;
  private selectedIdSpotify: string;
  private selectedItemJob: any[] = [];
  showDiscEdit: boolean;
  showButtonEditDisc: boolean;
  isAlbumsBigger: boolean;
  user: any;
  profileUpdate: any;
  skills: ExtendedProfile[] = [];
  profileSkills: ExtendedProfile[] = [];
  profileGenres: ExtendedProfile = {
    values: [],
    label: '',
    user_field_id: null,
  };
  profileInstruments: ExtendedProfile = {
    values: [],
    label: '',
    user_field_id: null,
  };
  profilePrize: ExtendedProfile = {
    values: [],
    label: '',
    user_field_id: null,
  };

  socials: ExtendedProfile[] = [];
  profileSocials: ExtendedProfile[] = [];
  selectedArtDisc: any[] = [];
  selectedRecordingDisc: any[] = [];
  selectedMasteringDisc: any[] = [];
  musician: boolean = false;
  producer: boolean = false;
  art: boolean = false;
  recording: boolean = false;
  mastering: boolean = false;
  disableOption: boolean = false;
  optionSelectedDiscArt: any[] = [];
  selectedInstrumentDisc: any[] = [];
  optionSelectedDiscRecording: any[] = [];
  optionSelectedDiscMastering: any[] = [];
  optionSelectedDiscInstrument: any[] = [];
  optionSelectedDiscProducer: string = null;
  dataEditDisc: any;
  isMobile: boolean;
  isMobileSlide: boolean = false;
  load: boolean;
  percent: 270;
  isOpen = false;
  referedData: ReferedInterface;
  totalDebitAmountsByBuyer: BuyerCurrencyAmount[] = [];
  perceent: string;
  active: number;
  clipboard: string;

  totalARS: number = 0;
  totalUSD: number = 0;

  totalARSganan: number = 0;
  totalUSDganan: number = 0;

  credit_amount: any = '';
  selectedCurrencyData: string;
  max_credit: number = 0;
  isRequesting: boolean = false;
  showModalGetCredit: boolean;
  isCreditInProgress: boolean = false;
  // referedData: ReferedInterface = {
  //   total_amount: 19.98,
  //   total_amount_current_month: 0,
  //   active_percentage: 0,
  //   suspended_percentage: 100,
  //   unique_buyers: 2,
  //   table_data: [
  //     {
  //       coupon: 'FERLA25OFF',
  //       owner: 7739,
  //       total_amount: '9.99',
  //       subscription_status: 'canceled',
  //       due_date: '2024-02-02 03:09:41',
  //       name: 'Javier Escobar',
  //       ganancia: 4.995
  //     },
  //     {
  //       coupon: 'FERLA25OFF',
  //       owner: 7739,
  //       total_amount: '9.99',
  //       subscription_status: 'canceled',
  //       due_date: '2024-02-02 03:09:41',
  //       name: 'Mijail',
  //       ganancia: 4.995
  //     },
  //     // ... otros elementos de table_data
  //   ]
  // };
  // active   = 100 - this.referedData.suspended_percentage;
  // inactive = this.referedData.suspended_percentage;
  // perceent = (((this.referedData.suspended_percentage - 100) *360)/100)+'deg';

  constructor(
    public sharedVarModalService: SharedVarModalService,
    public navCtrl: NavController,
    public loadingCtrl: LoadingController,
    public rest: RestService,
    private popoverController: PopoverController,
    public elementRef: ElementRef,
    public toastCtrl: ToastController,
    private cdRef: ChangeDetectorRef,
    public platform: Platform,
    private locationRouter: Location,
  ) {
    if (this.platform.is('android') || this.platform.is('ios')) {
      this.isMobile = true;
    }
  }

  ngOnInit() {
    this.getReferedData()
  }


  modalGetCredit() {
    this.showModalGetCredit = true; 
  }

  showModalCreditInProgress() {
    this.isCreditInProgress = !this.isCreditInProgress;
  }

  closeModalGetCredit() {
    this.showModalGetCredit = false;
  }

  toggleRowExpansion(row: TableRefered) {
    row.expanded = !row.expanded;
  }

  async copyToClipboard(element: HTMLElement) {
    const selection = window.getSelection();
    const range = document.createRange();
    range.selectNodeContents(element);

    selection.removeAllRanges();
    selection.addRange(range);
    document.execCommand('copy');
    selection.removeAllRanges();
    const toast = await this.toastCtrl.create({
      message: 'Código copiado en portapapeles',
      duration: 3000,
      position: 'top',
      color: 'success',
      icon: 'checkmark-outline'
    });
    await toast.present();
  }

  showModalAlertDelete() {
    this.modalShowAlertDelete = !this.modalShowAlertDelete;
    this.isOpenPost = false;
  }

  showModalAlertDeleteDisc() {
    this.modalShowAlertDeleteDisc = !this.modalShowAlertDeleteDisc;
    this.isOpenEditDisc = false;
  }

  ngAfterContentChecked() {
    if (this.swiper) {
      this.swiper.updateSwiper({});
    }

    this.cdRef.detectChanges();
  }

  gotoRegister() {
    this.navCtrl.navigateForward('/registro');
  }

  showModalRegisterTelco() {
    this.modalShowRegisterTelco = !this.modalShowRegisterTelco;
  }

  outData(ev) {
    if (ev && ev.editProfile) {
      this.navCtrl.navigateForward('mi-perfil');
    }

    if (ev && ev.login) {
      // this.openLogin();
      this.navCtrl.navigateRoot('/login')
    }

    if (ev && ev.home) {
      let url = '/home';
      this.locationRouter.go(url);
    }
  }

  refresh() {
    this.cdRef.detectChanges();
  }

  gotoCharge() {
    this.navCtrl.navigateForward('/charge');
  }


  gotoCourses() {
    this.navCtrl.navigateForward('/cursos');
  }
  gotoSubscription() {
    //this.navCtrl.navigateForward('landing/landing-page-cursos');
    this.navCtrl.navigateForward('/suscripciones');
  }

  gotoDetail(val) {
    console.log(val);
    this.navCtrl.navigateForward('cursos/' + val.id);
  }

  getSliderProfile() {
    const observable = this.rest._get(
      'profile/content/' + this.profile.id,
      'get'
    );
    observable.subscribe(
      (response) => {
        const res: any = response.body;
        this.getDataProfile();
        //console.log(res);
        this.dataSlider = res.content;
      },
      (resr) => {
        console.log(resr);
      }
    );
    return observable;
  }
  selectedCurrency(event: any) {
    const selectedData = event.detail.value;
    this.selectedCurrencyData = selectedData.currency;
    this.max_credit = selectedData.total_debit_amount;
    console.log('Selected Currency:', this.selectedCurrencyData);
    console.log('Credit Amount:', this.credit_amount);
    console.log('Max Amount:', this.max_credit);
    console.log(event.detail.value);
  }
  validateInput(event: any): void {
    let inputValue: string = event.target.value;
    inputValue = inputValue.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
    if (!/^0(\.|$)/.test(inputValue)) {
        inputValue = inputValue.replace(/^0+/, '');
    }
    event.target.value = inputValue;
}


  
  async requestCredit() {
    if (this.credit_amount > this.max_credit) {
      const toast = await this.toastCtrl.create({
        message: 'El Monto Excede al Acumulado',
        duration: 3000,
        position: 'top',
        color: 'danger',
        icon: 'warning-outline'
      });
      await toast.present();
      return;
    }
    this.isRequesting = true;
    const requestBody = {
      credit_amount: this.credit_amount,
      currency: this.selectedCurrencyData
    };

    const observable = this.rest._post(
      'coupons/request_credit',
      requestBody
    );

    observable.subscribe(
      async (response) => {
        const res: any = response.body;
        if (res) {
          console.log('Credit Request Data: ', res);
          this.getReferedData();
          this.closeModalGetCredit();
          this.showModalCreditInProgress();
        } else {
          console.log('Failed to submit credit request');
        }
        this.isRequesting = true;
      },
      (error) => {
        console.log('Error: ', error);
      }
    );

    return observable;
  }

  getReferedData() {
    const observable = this.rest._get(
      'coupons/referrals',
      'get'
    );
    observable.subscribe(
      async (response) => {
        const res: any = response.body;
        if (res) {
          this.referedData = res;
          this.perceent = (((this.referedData.active_percentage) * 360) / 100) + 'deg';
          this.active = this.referedData.table_data.filter(data => data.subscription_status.toLowerCase() === 'active' || data.subscription_status.toLowerCase() === 'authorized' || data.subscription_status.toLowerCase() === 'approved').length;

          console.log('Total Debit Amounts This Month: ', this.referedData.transactions.total_debit_amounts);

        } else {
          this.perceent = 0 + 'deg';
        }
      },
      (resr) => {
        console.log(resr);
      }
    );
    return observable;
  }

  getDataProfile() {
    let profiles: any[] = [];
    let dataP = '';
    if (this.profile.profiles) {
      //console.log(this.profile.profiles);
      for (const iterator of this.profile.profiles) {
        profiles.push(iterator.name);
      }
      dataP = profiles.toString();
      dataP = dataP.replace(/,/g, '.');
    }
    if (!profiles) {
      return;
    }

    this.rest
      ._get('profile/fields/' + dataP + '/' + this.profile.user_id, 'get')
      .subscribe(
        (response) => {
          const res: any = response.body;
          //console.log(res);
          this.dataDynamic = res.fields;
          let aux: boolean;
          try {
            for (let ita of this.dataDynamic) {
              let typeAux = true;
              for (let iterator of ita.fields) {
                aux = false;
                //console.log(iterator);
                if (typeof iterator.values === 'boolean') {
                  typeAux = false;
                }
                if (
                  typeAux &&
                  iterator.values &&
                  iterator.values.indexOf('[') >= 0
                ) {
                  aux = true;
                }
                if (aux && iterator.values && iterator.values.length > 0) {
                  //console.log(iterator.values);
                  iterator.values = JSON.parse(iterator.values);
                }
              }
              if (!typeAux) {
                ita.fields = ita.fields.sort((a1, b1) => b1.values - a1.values);
              }
              if (ita.type == 'social') {
                //console.log(ita);
                ita.fields = ita.fields.sort((b, a) =>
                  a.values.localeCompare(b.values)
                );
              }
            }
          } catch (error) {
            console.error(error);
          }

          //console.log(this.dataDynamic);
        },
        (resr) => {
          //this.loading.dismiss();
          console.log(resr);
        }
      );
  }

  async deletePostServicesAndSearch() {
    const item = this.dataPost;
    switch (item.type) {
      case 'lesson':
        const dataLesson = {
          lesson_id: item.id,
        };
        const auxLoading = await this.loadingCtrl.create({});
        await auxLoading.present();
        this.rest._post('lessons/lessons/deactivate', dataLesson).subscribe(
          async (resespone: any) => {
            this.getSliderProfile().subscribe(
              async () => {
                this.modalShowAlertDelete = false;
                await auxLoading.dismiss();
              },
              (resr) => {
                console.log(resr);
              }
            );
          },
          async (error) => {
            await auxLoading.dismiss();
            console.error('error: ', error);
          }
        );
        break;
      case 'sound-market':
        const dataService = {
          service_id: item.id,
        };
        const auxLoading2 = await this.loadingCtrl.create({});
        await auxLoading2.present();
        this.rest._post('services/services/deactivate', dataService).subscribe(
          async (resespone: any) => {
            this.getSliderProfile().subscribe(
              async () => {
                this.modalShowAlertDelete = false;
                await auxLoading2.dismiss();
              },
              (resr) => {
                console.log(resr);
              }
            );
          },
          async (error) => {
            await auxLoading2.dismiss();
            console.error('error: ', error);
          }
        );
        break;
    }
    switch (item.subtype) {
      case 'LessonSearch':
        const dataSearchLesson = {
          search_id: item.id,
        };
        const auxLoading3 = await this.loadingCtrl.create({});
        await auxLoading3.present();
        this.rest
          ._post('lessons/searches/deactivate', dataSearchLesson)
          .subscribe(
            async (resespone: any) => {
              this.getSearchSliderProfile().subscribe(
                async () => {
                  this.modalShowAlertDelete = false;
                  await auxLoading3.dismiss();
                },
                (resr) => {
                  console.log(resr);
                }
              );
            },
            async (error) => {
              await auxLoading3.dismiss();
              console.error('error: ', error);
            }
          );
        break;
      case 'ServiceSearch':
        const dataSearchService = {
          search_id: item.id,
        };
        const auxLoading4 = await this.loadingCtrl.create({});
        await auxLoading4.present();
        this.rest
          ._post('services/searches/deactivate', dataSearchService)
          .subscribe(
            async (resespone: any) => {
              this.getSearchSliderProfile().subscribe(
                async () => {
                  this.modalShowAlertDelete = false;
                  await auxLoading4.dismiss();
                },
                (resr) => {
                  console.log(resr);
                }
              );
            },
            async (error) => {
              await auxLoading4.dismiss();
              console.error('error: ', error);
            }
          );
        break;
    }
  }

  getSearchSliderProfile() {
    const observable = this.rest._get('profile/searches/' + this.profile.id);
    observable.subscribe(
      (response) => {
        const res: any = response.body;
        this.dataSearchSlider = res.content;
      },
      (resr) => {
        console.log(resr);
      }
    );
    return observable;
  }

  async dismissClick() {
    await this.popoverController.dismiss();
  }

  editPostAndSearch() {
    this.rest.storageSet('idSearch', this.dataPost.id);
    this.rest.storageSet('front_option', this.dataPost.front_option);
    this.dismissClick();
    const item = this.dataPost;
    switch (item.type) {
      case 'lesson':
        this.navCtrl.navigateForward('/publicar/class/' + item.id);
        break;
      case 'sound-market':
        this.navCtrl.navigateForward('publicar/service/' + item.id); //TODO:Revisar porque cuando se cambia a espanol serivico no lo reconoce
        break;
      default:
        break;
    }
    switch (item.front_option) {
      case '1':
        this.goToNewServices();
        break;
      case '2':
        this.goToNewServices();
        break;
      case '3':
        this.goToNewServices();
        break;
      case '4':
        this.goToNewServices();
        break;
      default:
        break;
    }
  }

  goToNewServices() {
    this.navCtrl.navigateForward('/home?proposal=true');
  }

  async showModalDisc() {
    this.showModalPublishDisc = !this.showModalPublishDisc;
    await this.closeShowAlbum();
    await this.getProfileInfo();
    this.navCtrl.navigateForward('/mi-perfil');
  }

  async getProfileInfo() {
    const auxLoading = await this.loadingCtrl.create({});
    await auxLoading.present();

    this.rest._get('accounts/basic-data').subscribe(
      (resx) => {
        const res: any = resx.body;
        this.profile = res;
        if (
          this.profile &&
          this.profile.bio &&
          this.profile.bio.trim() === '.'
        ) {
          this.profile.bio = '';
        }
        this.getSliderProfile();
        this.getSearchSliderProfile();
        let params = {
          id: this.profile.user_id,
        };
        this.rest._get('discs/user/' + this.profile.user_id).subscribe(
          async (resx2) => {
            const res2: any = resx2.body;
            let auxRes: any = res2;
            auxRes = auxRes.data.discs;
            auxRes = auxRes.sort(
              (a, b) =>
                new Date(b.release_date).getTime() -
                new Date(a.release_date).getTime()
            );
            this.profile.albums = auxRes;
            let auxAlbum = [];
            for (let index = 0; index < this.profile.albums.length; index++) {
              if (index < 9) {
                auxAlbum.push(this.profile.albums[index]);
              }
            }
            this.profile.albumsSort = auxAlbum;
            if (this.profile.albums.length > 6) {
              this.isAlbumsBigger = true;
            } else {
              this.isAlbumsBigger = false;
            }
            await auxLoading.dismiss();
          },
          async (res) => {
            await auxLoading.dismiss();
            //console.log(res);
          }
        );
        const user = this.user;
        user.profile_image = res.profile_image;
        user.profile_cover = res.profile_cover;
        this.rest.storageSet('user', user);
        if (this.profile.profiles && this.profile.profiles.length > 0) {
          for (const profile of this.profile.profiles) {
            this.profileUpdate.profiles.push(profile.name);
          }
        }

        //this.loadProfileEditLink();
        this.getExtendedProfile();
      },
      async (rees) => {
        await auxLoading.dismiss();
        //console.log('error loading data', rees);
      }
    );
  }

  // Cargar Skill y mostrar Skill
  getExtendedProfile() {
    let requestProfile = '';
    for (let i = 0; i < this.profile.profiles.length; i++) {
      requestProfile = requestProfile + this.profile.profiles[i].name;
      if (this.profile.profiles.length - 1 !== i) {
        requestProfile = requestProfile + '.';
      }
    }

    //this.profile.profiles
    this.rest
      ._get('profile/fields/' + requestProfile + '/' + this.profile.user_id)
      .subscribe(
        (response: any) => {
          this.getProfileSkill(response.body);
          this.getProfileSocial(response.body);
          this.getProfileGenre(response.body);
          this.getProfileInstruments(response.body);
          this.getProfilePrize(response.body);
        },
        (error) => {
          console.error('error: ', error);
        }
      );
  }

  private getProfileSkill(extendedProfile: any) {
    this.skills = [];
    this.profileSkills = [];
    let skills = extendedProfile.fields.filter(
      (sk) =>
        sk.type === 'group' &&
        sk.view === 'details' &&
        sk.fields &&
        sk.fields.length > 0 &&
        sk.fields[0].group &&
        sk.fields[0].group.toLowerCase().trim().startsWith('checkbox ')
    );
    skills = skills
      .map((sk1) => sk1.fields)
      .reduce((sk1, sk2) => sk1.concat(sk2));
    for (const skill of skills) {
      const sk: ExtendedProfile = {
        label: skill.label,
        user_field_id: skill.user_field_id,
        values: skill.values,
      };
      this.skills.push(sk);
      if (skill.values) {
        this.profileSkills.push(sk);
      }
    }
  }

  private getProfileGenre(extendedProfile: any) {
    let genresProfile: any = extendedProfile.fields.find(
      (g) => g.fields && g.fields.length > 0 && g.fields[0].label === 'Géneros'
    );
    if (genresProfile) {
      genresProfile = genresProfile.fields[0];
      let genresValue;
      try {
        genresValue = JSON.parse(genresProfile.values);
      } catch (e) {
        genresValue = [];
      }
      this.profileGenres = {
        user_field_id: genresProfile.user_field_id,
        values: genresValue,
        label: genresProfile.label,
      };
    }
  }

  private getProfileInstruments(extendedProfile: any) {
    let instrumentsProfile = extendedProfile.fields.find(
      (g) =>
        g.fields && g.fields.length > 0 && g.fields[0].label === 'Instrumentos'
    );
    if (instrumentsProfile) {
      instrumentsProfile = instrumentsProfile.fields[0];
      let instrumentsList;
      try {
        const parsedInstrumentList = JSON.parse(instrumentsProfile.values);
        instrumentsList = parsedInstrumentList.map((i) => {
          if (typeof i === 'string') {
            return { instrument: i, level: 0 };
          }
          return { instrument: i.instrument, level: i.level };
        });
      } catch (e) {
        instrumentsList = [];
      }
      this.profileInstruments = {
        user_field_id: instrumentsProfile.user_field_id,
        values: instrumentsList,
        label: instrumentsProfile.label,
      };
    }
  }

  private getProfilePrize(extendedProfile: any) {
    let prizeProfile = extendedProfile.fields.find(
      (g) => g.fields && g.fields.length > 0 && g.fields[0].label === 'Premios'
    );
    if (prizeProfile) {
      prizeProfile = prizeProfile.fields[0];
      let prizeValues;
      try {
        prizeValues = JSON.parse(prizeProfile.values);
      } catch (e) {
        prizeValues = [];
      }
      this.profilePrize = {
        user_field_id: prizeProfile.user_field_id,
        values: prizeValues,
        label: prizeProfile.label,
      };
    }
  }

  private getProfileSocial(extendedProfile: any) {
    this.socials = [];
    this.profileSocials = [];
    let socials: any = extendedProfile.fields.find(
      (sc) => sc.type && sc.type === 'social'
    );
    socials = socials ? socials.fields : [];
    for (const social of socials) {
      const scial: ExtendedProfile = {
        label: social.label,
        user_field_id: social.user_field_id,
        values: social.values && social.values === '.' ? null : social.values,
        image: social.image,
      };
      this.socials.push(scial);
      if (scial.values) {
        this.profileSocials.push(scial);
      }
    }
  }

  closeShowAlbum() {
    if (this.edit) {
      this.scrolltoTop();
      this.helpAlbum = false;
      this.sectionEdit = this.helpAlbum ? 'album' : null;
      this.disabledEdit = false;
      this.clearAllDisc();
      this.seeAllAlbumsEdit = false;
    }
  }

  clearAllDisc() {
    this.selectedDiscSpotifyImg = '';
    this.selectedDiscSpotifyArtist = '';
    this.selectedDiscSpotifyName = '';
    this.selectedDiscSpotifyReleaseDate = '';
    this.selectedDiscSpotifyExternalUrl = '';
    this.selectedIdSpotify = '';
    this.showSelectedDiscSpotify = false;
    this.selectedArtDisc = [];
    this.selectedRecordingDisc = [];
    this.selectedMasteringDisc = [];
    this.selectedInstrumentDisc = [];
    this.optionSelectedDiscProducer = null;
    this.optionSelectedDiscRecording = [];
    this.optionSelectedDiscMastering = [];
    this.optionSelectedDiscInstrument = [];
    this.optionSelectedDiscArt = [];
    this.showButtonEditDisc = false;
  }

  scrolltoTop(): void {
    const top = this.elementRef.nativeElement.querySelector('#top');
    top.scrollIntoView({ behavior: 'smooth' });
  }

  async deleteDiscSpotify() {
    const item = this.dataEditDisc;
    const auxLoading = await this.loadingCtrl.create({});
    await auxLoading.present();
    this.rest._delete(`discs/${item.id}`).subscribe(
      async (resespone: any) => {
        await this.getProfileInfo();
        this.modalShowAlertDeleteDisc = false;
        await auxLoading.dismiss();
      },
      async (error) => {
        await auxLoading.dismiss();
        console.error('error: ', error);
      }
    );
  }

  editDiscSpotify() {
    this.dismissClick();
    this.showButtonEditDisc = true;
    const item = this.dataEditDisc;
    this.selectedDiscSpotifyImg = item.cover;
    this.selectedDiscSpotifyArtist = item.name;
    this.selectedDiscSpotifyName = item.name;
    this.selectedDiscSpotifyReleaseDate = item.release_date;
    this.selectedDiscSpotifyExternalUrl = item.external_url;
    this.selectedIdSpotify = item.player_info;
    const discs: any[] = item.user_disc;
    const userDisc = discs.find(
      (disc) => disc.app_user_id === this.user.user_id
    );
    if (userDisc) {
      const job: any[] = JSON.parse(userDisc.job);
      if (job.some((value) => value instanceof Array)) {
        this.selectedArtDisc = job[0];
        this.selectedRecordingDisc = job[1];
        this.selectedMasteringDisc = job[2];
        this.selectedInstrumentDisc = job[3];
        this.optionSelectedDiscProducer = job[4];
        this.optionSelectedDiscArt = job[0];
        this.optionSelectedDiscRecording = job[1];
        this.optionSelectedDiscMastering = job[2];
        this.optionSelectedDiscInstrument = job[3];
      } else {
        job.forEach((jobItem) => {
          if (jobItem.startsWith('Arte:')) {
            this.optionSelectedDiscArt = jobItem
              .replace('Arte:', '')
              .trim()
              .split(',');
          }
          if (jobItem.startsWith('Productor:')) {
            this.optionSelectedDiscProducer = jobItem
              .replace('Productor:', '')
              .trim();
          }
          if (jobItem.startsWith('Grabación:')) {
            this.optionSelectedDiscRecording = jobItem
              .replace('Grabación:', '')
              .trim()
              .split(',');
          }
          if (jobItem.startsWith('Mezcla:')) {
            this.optionSelectedDiscMastering = jobItem
              .replace('Mezcla:', '')
              .trim()
              .split(',');
          }
          if (jobItem.startsWith('Músico:')) {
            this.optionSelectedDiscInstrument = jobItem
              .replace('Músico:', '')
              .trim()
              .split(',');
          }
        });
      }
    }
    this.showSelectedDiscSpotify = true;
    this.showDiscEditAlbums();
    //this.showModalPublishDisc = true;
    /*this.rest._put(`discs/${item.id}`, item).subscribe((resespone: any) => {
     console.log(resespone.body);
   }, (error) => {
     console.error('error: ', error);
   });*/
  }

  showDiscEditAlbums() {
    if (this.edit) {
      this.scrolltoTop();
      this.helpAlbum = true;
      this.sectionEdit = this.helpAlbum ? 'album' : null;
      this.disabledEdit = true;
      this.seeAllAlbumsEdit = false;
    }
  }

  shareProfileDesktop() {
    const url = 'https://v2.louderband.com/perfiles/' + this.user.user_id;
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(url)
        .then(async () => {
          const toast = await this.toastCtrl.create({
            message: 'La URL se ha copiado al portapapeles.',
            duration: 2000,
            position: 'top',
          });
          await toast.present();
        })
        .catch(async () => {
          const toast = await this.toastCtrl.create({
            message: 'No se pudo copiar la URL al portapapeles.',
            duration: 2000,
            position: 'top',
          });
          await toast.present();
        });
    }
  }

  shareDevice(index: number) {
    const element = document.querySelector('share-menu') as ShareMenu;
    element.targets[index].share(element);
  }

  gotoHome() {
    this.navCtrl.navigateBack('home');
  }

}
